import { CalendarDays } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { eventDateLabel, eventTimeLabel } from '@/frontend/features/Fde/projectCalendarEvents'
import type { FdeCopy, TimelineEvent } from '@/frontend/features/Fde/types'

export default function ProjectCalendarEvent({ event, copy, onSelect }: {
  event: TimelineEvent; copy: FdeCopy; onSelect: () => void
}) {
  const time = eventTimeLabel(event, copy.timeline.all_day)
  return <Tooltip delayDuration={250}>
    <TooltipTrigger asChild>
      <button type="button" aria-label={event.summary} onClick={onSelect}
        className="flex w-full items-start gap-1.5 rounded-md border border-border/70 bg-background px-1.5 py-1.5 text-left text-[10px] leading-4 hover:bg-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring">
        <CalendarDays className="mt-0.5 size-3 shrink-0 text-muted-foreground" />
        <span className="min-w-0"><span className="line-clamp-2 font-medium">{event.summary}</span>{!event.all_day && <span className="text-muted-foreground">{time}</span>}</span>
      </button>
    </TooltipTrigger>
    <TooltipContent side="top" sideOffset={8} className="max-w-72 p-3 text-left text-wrap">
      <p className="text-[10px] text-muted-foreground">{copy.management.calendar_event}</p>
      <p className="mt-1 text-xs font-medium leading-5">{event.summary}</p>
      <p className="mt-2 text-[11px]">{eventDateLabel(event)} · {time}</p>
      {event.manager_name && <p className="mt-1 text-[11px] text-muted-foreground">{event.manager_name}</p>}
      {event.location && <p className="mt-1 text-[11px] text-muted-foreground">{event.location}</p>}
    </TooltipContent>
  </Tooltip>
}
